export type CourseSrsRepetitions = 1 | 2 | 3;

export const DEFAULT_COURSE_SRS_REPETITIONS: CourseSrsRepetitions = 2;

export const COURSE_SRS_REPETITION_OPTIONS: {
  value: CourseSrsRepetitions;
  label: string;
}[] = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
];

const COURSE_SRS_REPETITIONS = new Set<number>([1, 2, 3]);

export function normalizeCourseSrsRepetitions(
  value: unknown,
): CourseSrsRepetitions {
  const numeric =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number.parseInt(value, 10)
        : NaN;
  if (COURSE_SRS_REPETITIONS.has(numeric)) {
    return numeric as CourseSrsRepetitions;
  }
  return DEFAULT_COURSE_SRS_REPETITIONS;
}
